import React from 'react';
import Button from '../../../components/ui/Button';


const SocialLoginButtons = ({ onGoogleLogin, onDiscordLogin, onTwitchLogin, isLoading }) => {
  return (
    <div className="space-y-3">
      <Button
        variant="outline"
        size="lg"
        fullWidth
        iconName="Chrome"
        iconPosition="left"
        onClick={onGoogleLogin}
        disabled={isLoading}
        className="bg-white/5 border-white/10 hover:bg-white/10 text-foreground"
      >
        Continue with Google
      </Button>
      
      <Button
        variant="outline"
        size="lg"
        fullWidth
        iconName="MessageCircle"
        iconPosition="left"
        onClick={onDiscordLogin}
        disabled={isLoading}
        className="bg-[#5865F2]/10 border-[#5865F2]/20 hover:bg-[#5865F2]/20 text-foreground"
      >
        Continue with Discord
      </Button>

      <Button
        variant="outline"
        size="lg"
        fullWidth
        iconName="Twitch"
        iconPosition="left"
        onClick={onTwitchLogin}
        disabled={isLoading}
        className="bg-[#9146FF]/10 border-[#9146FF]/20 hover:bg-[#9146FF]/20 text-foreground"
      >
        Continue with Twitch
      </Button>
    </div>
  );
};

export default SocialLoginButtons;
